import { ProjectStore } from '@/types';
import projectInfoService from '@/services/Navigation/ProjectInfoService';
import StorableElementValues from '@/store/dataTransfertObject/StorableElementValues';

/**
 * Gère ajout/supression/modification des ProjectStore dans le store
 */
export default function updateProjectStore(
	projStores: ProjectStore[],
	storableElementValues: StorableElementValues
): void {
	// 1. Récupération du store projet existant
	let projectStore = projectInfoService.getProjectStore(storableElementValues.id) as ProjectStore;

	// 2. Créer le store projet s'il n'existe pas
	if (undefined === projectStore) {
		projectStore = {
			id: ''
		};
	}

	// 3. merge du project Store et de l'objet de transfert de données
	projectStore = {
		...projectStore,
		...storableElementValues
	};

	// 4. Liste les id des stores projet présents
	const existingIds = projStores.map((projectStore) => {
		return projectStore.id;
	});

	// 5. Ajoute ou remplace selon le besoin
	if (!existingIds.includes(projectStore.id)) {
		projStores.push(projectStore);

		return;
	}

	projStores.forEach((element, index) => {
		if (element.id === projectStore.id) {
			projStores[index] = projectStore;
		}
	});
}
